module.exports = __webpack_public_path__ + "static/media/food.c08578fb.JPG";